import type { z } from 'zod';
import { ShippingForm } from '@client/components/shipping/shipping-form.tsx';
import type { UseFormReturn } from 'react-hook-form';
import type { FormSchema } from '@client/components/shipping/shipping.tsx';
import type { ICartSchema } from '@r/types/zod-schemas.ts';
import { useTranslation } from 'react-i18next';

const ShippingTemplate = ({
  form
}: {
  cart: z.infer<typeof ICartSchema>;
  form: UseFormReturn<z.infer<typeof FormSchema>>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex items-center pb-4">
        <h1 className="text-[2rem] leading-[2.75rem] font-semibold">{t('shipping.title')}</h1>
      </div>

      <ShippingForm form={form} />
    </>
  );
};

export { ShippingTemplate };
